<script>
    import { _ } from "svelte-i18n";

    export let text = "";

    let active = false;


</script>

<style>
    .html_text {
        text-overflow: unset;
        white-space: initial;
        font-weight: normal;
        font-size: 15px;
    }
</style>

<span on:click={()=>{ active = !active }} class="cursor-pointer text-white bg-slate-700 rounded-[50%] w-[18px] inline-block text-center text-[12px]">?</span>
{#if active}
<div class="fixed top-0 right-0 left-0 w-full h-full p-4 bg-[rgba(0,0,0,0.7)] rounded-lg shadow-lg border border-gray-300 z-30 flex items-center justify-center">
    <div class="flex justify-between items-center bg-white p-5 w-[300px] rounded">
        <p class="text-sm text-gray-700 html_text">{@html text}</p>
        <span class="cursor-pointer mr-4 text-black hover:text-gray-700 font-bold" on:click={()=>{ active = false; }}>
            ✕
        </span>
    </div>
</div>
{/if}
